import App from 'app/app.js';
import LtSelectionDrawerCtrl from 'app/directive/LtSelectionDrawerCtrl.js';

function LtConfirmExistingStudentCtrl(
  $scope,
  $timeout,
  SubjectStore,
  ShoppingCartStore,
  RedirectionService,
  BlockService,
  JobStore,
  JobCleanUpService,
  GradeService,
  CommonService,
  RouterService,
  ErrorLogService,
  ConfirmSchoolService
) {
  LtSelectionDrawerCtrl.call(this, $scope, $timeout);
  this.studentGrade = $scope.studentGrade;
  this.allSubjects = SubjectStore.getSortedVerifiedAndJobSubjects();
  this.subject = SubjectStore.getSelectedSubject(false);
  this.confirmExistingStudentPopup = true;
  this.confirmSchoolDetailsPopup = false;
  this.schoolName = $scope.schoolName;
  var closeModal = this.close.bind(this);

  this.close = function () {
    closeModal();
    $timeout(
      function () {
        this.confirmExistingStudentPopup = true;
        this.confirmSchoolDetailsPopup = false;
      }.bind(this),
      100
    );
  };

  this.getPreviewImageUrl = function () {
    this.subject = SubjectStore.getSelectedSubject(false);
    if (this.subject && this.subject.previewImageUrl) {
      return this.subject.previewImageUrl;
    }
  };
  this.clearPictureDayForm = function () {
    $scope.onCancellation();
  };

  this.getStudentNameAfterTruncated = function (subject) {
    this.subject = SubjectStore.getSelectedSubject(false);
    if (this.subject) {
      if (this.subject.subjectFirstName === this.subject.subjectLastName) {
        return this.subject.subjectFirstName;
      } else {
        return this.subject.subjectFirstName + ' ' + this.subject.subjectLastName;
      }
    }
    return null;
  };

  this.getStudentFirstName = function (subject) {
    this.subject = SubjectStore.getSelectedSubject(false);
    if (this.subject) {
      return ' ' + this.subject.subjectFirstName;
    }
  };

  this.getSchoolNameAfterTruncated = function (nameSize) {
    this.subject = SubjectStore.getSelectedSubject(false);
    if (this.subject) {
      if (this.subject.updatedAccount) {
        return this.subject.updatedAccount.accountName;
      } else if (
        this.subject.currentEvent &&
        this.subject.currentEvent.event &&
        this.subject.currentEvent.event.accountName
      ) {
        return this.subject.currentEvent.event.accountName;
      } else if (
        this.subject.selectedEvent &&
        this.subject.selectedEvent.eventType &&
        this.subject.selectedEvent.eventType.account
      ) {
        return this.subject.selectedEvent.eventType.account.accountName;
      } else if (this.subject.account && this.subject.account.accountAlias) {
        return this.subject.account.accountAlias;
      } else {
        var event = this.subject && this.subject.masterEvents && this.subject.masterEvents[0];
        return event && event.eventType && event.eventType.account.accountName;
      }
    }
    return null;
  };

  this.getSubjectGradeInfo = function () {
    return SubjectStore.getSubjectGrade();
  };

  this.confirmSchoolDetails = function () {
    this.subject = SubjectStore.getSelectedSubject(false);
    if (this.subject) {
      this.subject.fromConfirmExistingStudentPopup = true;
      SubjectStore.setFromConfirmExistingStudent(true);
      return ConfirmSchoolService.onSubjectSelection(this.subject, SubjectStore.getSelectedMasterEvent());
    }
  };

  this.editDetails = function () {
    $timeout(
      function () {
        this.confirmExistingStudentPopup = false;
        this.confirmSchoolDetailsPopup = true;
      }.bind(this),
      100
    );
  };
}

App.controller('LtConfirmExistingStudentCtrl', [
  '$scope',
  '$timeout',
  'SubjectStore',
  'ShoppingCartStore',
  'RedirectionService',
  'BlockService',
  'JobCleanUpService',
  'JobStore',
  'GradeService',
  'CommonService',
  'RouterService',
  'ErrorLogService',
  'ConfirmSchoolService',
  LtConfirmExistingStudentCtrl
]);
